/**
 * Whether the signed-in admin-pool user is a super admin.
 *
 * No existing super-admin-ui hook exposes the admin-pool `custom:superAdminRole`
 * claim (useStaffAccess is a different, RubyTill-staff-only permission system —
 * see src/hooks/useStaffAccess.tsx). Decoding the id token here is the only
 * client-side signal; the server is the real gate on every mutating call
 * (D9 — mutating business-transfer actions are super-admin only).
 *
 * Single copy shared by BusinessTransfersPage, NewTransferModal and
 * TransferDetailPage — do not re-implement this inline elsewhere.
 */
export function useIsSuperAdmin(): boolean {
  try {
    const token = localStorage.getItem('jwtToken') || '';
    const claims = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return claims['custom:superAdminRole'] === 'super_admin' || claims['custom:role'] === 'super_admin';
  } catch { return false; }
}
